import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output", "code"]

  declare outputTarget: HTMLElement
  declare codeTarget: HTMLElement

  connect() {
    console.log("[DebugScanner] Connected")
  }

  onScan(event: CustomEvent) {
    // The bridge--barcode-scanner:scanned event provides { barcode: string }
    const { barcode } = event.detail
    
    if (barcode) {
      this.codeTarget.textContent = barcode
      this.outputTarget.classList.remove("hidden")
      
      console.log("[DebugScanner] Received scanned barcode:", barcode)
    }
  }
}
